import {
  ACCOUNT_DISTRIBUTION_PATH,
  ACCOUNT_REFUND_PATH,
  ACCOUNT_TRANSFER_HISTORY_PATH,
} from 'core/cuenta/routes';
import { MenuItems } from './models/MenuItemsModel';
import { CREATION_USERS_PATH, LIST_USERS_PATH } from 'user/routes';
import {
  LIST_CARDS_PATH,
  SEARCH_CARD_TOTALS_BY_PERIOD_PATH,
  SEARCH_CARD_TOTALS_PATH,
} from 'core/tarjeta/routes';
import {
  COST_CENTRE_LIST_BY_PERIOD_PATH,
  COST_CENTRE_LIST_PATH,
} from 'core/centrocosto/routes';
import {
  SEARCH_BUSINESS_ACCOUNT_REPORT_PATH,
  SEARCH_BUSINESS_COSTCENTRE_REPORT_PATH,
  SEARCH_BUSINESS_TOTALS_BY_PERIOD_PATH,
  SEARCH_BUSINESS_TOTALS_PATH,
} from 'core/empresa/routes';
import { CONSULTA_REPORTE } from 'user/constants/Funcionalidad';
import { CONSULTAR_REPORTE_PATH } from 'core/reporte/routes';

export const MENU_ITEMS: MenuItems = {
  sections: [
    {
      items: [
        {
          icon: 'HomeIcon-1',
          functions: ['PERMITIR'],
          name: 'Inicio',
          path: '/',
        },
      ],
    },
    {
      abbr: 'Organización',
      name: 'Organización',
      items: [
        {
          icon: 'PaymentCardIcon',
          functions: ['ABM_TARJETA', 'CONSULTA_TARJETA'],
          name: 'Tarjetas',
          path: LIST_CARDS_PATH,
        },
        {
          icon: 'BankIcon',
          functions: ['ABM_CENTRO_COSTO', 'CONSULTA_CENTRO_COSTO'],
          name: 'Centros de costos',
          path: COST_CENTRE_LIST_PATH,
        },
      ],
    },

    {
      abbr: 'Periodos',
      name: 'Información sobre periodos',
      items: [
        {
          icon: 'GraphIcon',
          name: 'Período actual',
          items: [
            {
              functions: ['DENEGAR'],
              name: 'Información por Centro de Costos',
              path: COST_CENTRE_LIST_PATH,
            },
            {
              functions: ['DENEGAR'],
              name: 'Información y movimientos por tarjeta',
              path: SEARCH_CARD_TOTALS_PATH,
            },
            {
              functions: ['DENEGAR'],
              name: 'Información por cuenta',
              path: SEARCH_BUSINESS_TOTALS_PATH,
            },
          ],
        },
        {
          icon: 'ArchiveIcon',
          name: 'Período anterior',
          items: [
            {
              functions: ['DENEGAR'],
              name: 'Centro de costos',
              path: COST_CENTRE_LIST_BY_PERIOD_PATH,
            },
            {
              functions: ['DENEGAR'],
              name: 'Movimientos por tarjetas',
              path: SEARCH_CARD_TOTALS_BY_PERIOD_PATH,
            },
            {
              functions: ['DENEGAR'],
              name: 'Consolidado últimos meses por cuenta',
              path: SEARCH_BUSINESS_ACCOUNT_REPORT_PATH,
            },
            {
              functions: ['DENEGAR'],
              name: 'Consolidado últimos meses por centro de costos',
              path: SEARCH_BUSINESS_COSTCENTRE_REPORT_PATH,
            },
            {
              functions: ['DENEGAR'],
              name: 'Cuentas',
              path: SEARCH_BUSINESS_TOTALS_BY_PERIOD_PATH,
            },
          ],
        },
      ],
    },
    {
      abbr: 'Transferencias',
      name: 'Distribución y devolución de fondos',
      items: [
        {
          icon: 'MoneyTransferIcon',
          functions: ['DISTRIBUCION'],
          name: 'Realizar distribución',
          path: ACCOUNT_DISTRIBUTION_PATH,
        },
        // {
        //   icon: 'FastForwardIcon',
        //   functions: ['DISTRIBUCION'],
        //   name: 'Realizar transferencia',
        //   path: COST_CENTRE_MASS_DISTRIBUTION_PATH,
        // },
        {
          icon: 'ArrowReturnLeft',
          functions: ['DEVOLUCION_TOTAL', 'DEVOLUCION_PARCIAL'],
          name: 'Realizar devolución',
          path: ACCOUNT_REFUND_PATH,
        },
        {
          icon: 'ListIcon',
          functions: ['CONSULTA_TRANSFERENCIA'],
          name: 'Transferencias realizadas',
          path: ACCOUNT_TRANSFER_HISTORY_PATH,
        },
      ],
    },
    {
      abbr: 'Usuarios',
      name: 'Usuarios',
      items: [
        {
          icon: 'MoneyTransferIcon',
          functions: ['ABM_USUARIO'],
          name: 'Crear usuario',
          path: CREATION_USERS_PATH,
        },
        {
          icon: 'UsersIcon',
          functions: ['ABM_USUARIO'],
          name: 'Listado de Usuarios',
          path: LIST_USERS_PATH,
        },
      ],
    },
    {
      abbr: 'Reportes',
      name: 'Reportes',
      items: [
        {
          icon: 'ClipboardFileIcon',
          functions: [CONSULTA_REPORTE],
          name: 'Reportes',
          path: CONSULTAR_REPORTE_PATH,
        },
      ],
    },

  ],
};
